import { render } from "./Complete.vue?vue&type=template&id=82e8afaa&scoped=true"
import script from "./Complete.vue?vue&type=script&lang=js"
export * from "./Complete.vue?vue&type=script&lang=js"

import "./Complete.vue?vue&type=style&index=0&id=82e8afaa&scoped=true&lang=css"
import "./Complete.vue?vue&type=style&index=1&id=82e8afaa&lang=css"

import exportComponent from "C:\\wamp64\\www\\ehaat-ambulance-game\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82e8afaa"]])

export default __exports__